export default __webpack_public_path__ + "static/media/separate-bathroom-shower.d17f8a55.svg";